import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as PlannerActions from './planner.actions';
import { DEFAULT_PLANNERS } from './planner.constants';

@Injectable()
export class PlannerEffects {
  private actions$ = inject(Actions);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlannerActions.loadPlanners),
      map(() => PlannerActions.loadPlannersSuccess({ planners: DEFAULT_PLANNERS })),
      catchError((error) =>
        of(
          PlannerActions.loadPlannersFailure({
            error: error?.message || 'Failed to load planners',
          })
        )
      )
    )
  );
}
